import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import styled from "styled-components";

const { blue, carbon } = colorsPalettes;

export const MainCompetitorWrapper = styled(FlexRow)<{ disabled?: boolean; isActive?: boolean }>`
    align-items: center;
    margin-bottom: 8px;
    padding: 4px 0;
    cursor: ${({ disabled, isActive = true }) => (disabled ? "not-allowed" : isActive ? "pointer" : "default")};
    > * {
        margin-right: 16px;
    }
    transition: fill 300ms ease-out;
    &:hover {
        .SWReactIcons {
            svg {
                path {
                    fill: ${({ disabled, isActive = true }) => (!isActive ? carbon[50] : !disabled && blue[500])};
                }
            }
            svg g g use {
                fill: ${blue[500]};
            }
        }
    }
    .SWReactIcons {
        svg g g use {
            fill: ${blue[400]};
        }
    }
    svg {
        path {
            fill: ${({ isActive = true }) => !isActive && carbon[50]};
        }
    }
`;

export const WebsiteName = styled.span`
    ${setFontVariant("subtitle1")};
    max-width: 380px;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
